import { useMemo } from 'react';

export const dateConvert = (date) => {
  const d = new Date(date);
  const prettyDate = d.toLocaleDateString('en-gb', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  });
  return useMemo(() => prettyDate, [date]);
};

// import React, { Component } from 'react';
// import PropTypes from 'prop-types';

// export default class DateConvert extends Component {
//   constructor(props) {
//     super(props);
//     //   this.handleDate = this.handleDate.bind(this);
//   }

//   render() {
//     let d = new Date(this.props.dateString);
//     let year = d.getFullYear();
//     let month = d.getMonth();
//     let m;
//     switch (month) {
//       case 0:
//         m = 'January';
//         break;
//       case 1:
//         m = 'February';
//         break;
//       case 2:
//         m = 'March';
//         break;
//       case 3:
//         m = 'April';
//         break;
//       case 4:
//         m = 'May';
//         break;
//       case 5:
//         m = 'June';
//         break;
//       case 6:
//         m = 'July';
//         break;
//       case 7:
//         m = 'August';
//         break;
//       case 8:
//         m = 'September';
//         break;
//       case 9:
//         m = 'October';
//         break;
//       case 10:
//         m = 'November';
//         break;
//       case 11:
//         m = 'December';
//         break;
//     }
//     return (
//       <span className={this.props.class}>{m + ' ' + year.toString()}</span>
//     );
//   }
// }
// DateConvert.propTypes = {
//   dateString: PropTypes.string.required,
// };
